import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config/api';
import './Management.css';

const AboutVideoManagement = () => {
  const { token } = useAuth();
  const [currentVideo, setCurrentVideo] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchCurrentVideo();
  }, [token]);

  const fetchCurrentVideo = async () => {
    try {
      const res = await fetch(`${API_URL}/api/about-setting?populate=*`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return;
      const data = await res.json();
      const video = data.data?.attributes?.video?.data;
      if (video) {
        setCurrentVideo({
          id: video.id,
          url: `${API_URL}${video.attributes.url}`,
          name: video.attributes.name,
        });
      }
    } catch (err) {
      console.error('Kan video niet laden:', err);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setVideoFile(file);
  };

  const handleSave = async () => {
    if (!videoFile) return;
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      // Upload video to Strapi media library
      const uploadData = new FormData();
      uploadData.append('files', videoFile);
      const uploadRes = await fetch(`${API_URL}/api/upload`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: uploadData,
      });
      if (!uploadRes.ok) throw new Error('Video uploaden mislukt');
      const uploaded = await uploadRes.json();
      const fileId = uploaded[0].id;

      // Link video to about-setting
      const updateRes = await fetch(`${API_URL}/api/about-setting`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ data: { video: fileId } }),
      });
      if (!updateRes.ok) throw new Error('Instellingen opslaan mislukt');

      setSuccess('✓ Video succesvol opgeslagen!');
      setVideoFile(null);
      await fetchCurrentVideo();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleRemove = async () => {
    if (!confirm('Wil je de video verwijderen?')) return;
    setSaving(true);
    try {
      await fetch(`${API_URL}/api/about-setting`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ data: { video: null } }),
      });
      setCurrentVideo(null);
      setSuccess('✓ Video verwijderd');
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Over Ons Video</h1>
      </div>

      {error && <div className="error-message">{error}</div>}
      {success && (
        <div style={{ marginBottom: '1.5rem', padding: '1rem', borderRadius: '6px', background: '#1a3a1a', border: '1px solid #00ff88', color: '#00ff88' }}>
          {success}
        </div>
      )}

      <div className="admin-form">
        {currentVideo ? (
          <div className="form-group">
            <label>Huidige video</label>
            <video
              src={currentVideo.url}
              controls
              style={{ width: '100%', maxWidth: '560px', borderRadius: '8px', display: 'block', marginBottom: '8px' }}
            />
            <p style={{ color: '#aaa', fontSize: '13px', marginBottom: '8px' }}>{currentVideo.name}</p>
            <button
              type="button"
              className="btn-delete"
              onClick={handleRemove}
              disabled={saving}
            >
              Video verwijderen
            </button>
          </div>
        ) : (
          <p style={{ color: '#aaa', marginBottom: '1.5rem' }}>Geen video ingesteld — de gradient achtergrond wordt getoond.</p>
        )}

        <div className="form-group">
          <label>{currentVideo ? 'Nieuwe video uploaden (vervangt huidige)' : 'Video uploaden'}</label>
          <input
            type="file"
            accept="video/mp4,video/webm,video/ogg,video/quicktime,.mov"
            onChange={handleFileChange}
          />
          {videoFile && (
            <p style={{ color: '#00d9ff', fontSize: '13px', marginTop: '6px' }}>
              ✓ Geselecteerd: {videoFile.name} ({(videoFile.size / 1024 / 1024).toFixed(1)} MB)
            </p>
          )}
          <p style={{ color: '#555', fontSize: '12px', marginTop: '6px' }}>
            Ondersteund: MP4, MOV, WebM — max. 250 MB. De video speelt automatisch af op de achtergrond (zonder geluid).
          </p>
        </div>

        <button
          type="button"
          className="btn-submit"
          onClick={handleSave}
          disabled={saving || !videoFile}
        >
          {saving ? 'Bezig met uploaden...' : 'Video Opslaan'}
        </button>
      </div>
    </div>
  );
};

export default AboutVideoManagement;
